module.exports = function () {
	const prevButton = document.querySelector('.prev_button');
	const nextButton = document.querySelector('.next_button');

    $('.fs-carousel').flickity({
		cellAlign: 'left',
		setGallerySize: false,
		contain: true,
		prevNextButtons: true,
		pageDots: false,
		wrapAround: true,
		autoPlay: 4000,
		percentPosition: false,
		pageDots: false,
	});

	if (prevButton) {
		prevButton.addEventListener('click', function () {
			$('.fs-carousel').flickity('previous');
		});
	}

	if (nextButton) {
		nextButton.addEventListener('click', function () {
			$('.fs-carousel').flickity('next');
		});
	}
}
